// keys will be moved to file
export const ACCESS_KEY_ID = '123';
export const SECRET_ACCESS_KEY = '123';
export const EXPIRES_URL_TIME = 3600;
export const REGION = 'us-east-1';
